import {
  getPalletFootprintMetres,
  getPalletTareKg,
} from '../../../../constants/pallets';

const POUNDS_PER_KILOGRAM = 2.2;

const roundToTwoDecimals = (value: number) => Math.round(value * 100) / 100;

export const getStandardPalletLengthInMetres = (palletType: string) =>
  getPalletFootprintMetres(palletType)?.lengthM;

export const getStandardPalletWidthInMetres = (palletType: string) =>
  getPalletFootprintMetres(palletType)?.widthM;

export const getStandardPalletWeightInKg = (palletType: string) =>
  getPalletTareKg(palletType) ?? undefined;

export const getStandardPalletWeightInLb = (palletType: string) => {
  const tareKg = getPalletTareKg(palletType);
  return tareKg === null
    ? undefined
    : roundToTwoDecimals(tareKg * POUNDS_PER_KILOGRAM);
};
